'use strict'

const coordinates = ['from', 'to', 'line', 'endline', 'alias', 'ordinal'].map(name => 'data-comment-' + name)

function pills (roots) {
  const found = []
  for (const root of Array.isArray(roots) ? roots : [roots]) {
    if (!root) continue
    if (root.matches && root.matches('.critic-comment')) found.push(root)
    found.push(...root.querySelectorAll('.critic-comment'))
  }
  return found
}

function stripCriticCoordinates (root) {
  for (const pill of pills(root)) {
    for (const attribute of coordinates) pill.removeAttribute(attribute)
    for (const alias of pill.querySelectorAll('.critic-comment-alias')) alias.removeAttribute('id')
  }
}

function syncCriticCoordinates (rendered, root) {
  const source = new Map(pills(rendered).map(pill => [pill.id, pill]))
  for (const pill of pills(root)) {
    const current = source.get(pill.id)
    for (const attribute of coordinates) {
      if (current && current.hasAttribute(attribute)) pill.setAttribute(attribute, current.getAttribute(attribute))
      else pill.removeAttribute(attribute)
    }
    const alias = current && current.querySelector('.critic-comment-alias')
    const oldAlias = pill.querySelector('.critic-comment-alias')
    if (alias && oldAlias) oldAlias.id = alias.id
    else if (alias) pill.insertBefore(alias.cloneNode(true), pill.firstChild)
    else if (oldAlias) oldAlias.remove()
  }
}

function highlightCriticLine (root, line) {
  const active = new Set()
  for (const pill of pills(root)) {
    const first = Number(pill.getAttribute('data-comment-line'))
    const last = Number(pill.getAttribute('data-comment-endline'))
    const matches = Number.isInteger(line) && line > 0 && first > 0 && first <= line && line <= last
    pill.classList.toggle('critic-cursor-active', matches)
    if (matches) active.add(pill.id)
  }
  for (const bubble of root.querySelectorAll('.critic-margin-bubble')) {
    bubble.classList.toggle('critic-cursor-active', active.has(bubble.getAttribute('data-comment-id')))
  }
  for (const group of root.querySelectorAll('.critic-margin-overflow')) {
    const control = group.previousElementSibling
    if (control && control.classList.contains('critic-margin-more')) {
      control.classList.toggle('critic-cursor-active', !!group.querySelector('.critic-cursor-active'))
    }
  }
}

function criticHashTarget (root, hash) {
  if (!/^#(?:comment-[0-9a-f]{8}(?:-\d+)?|cl[1-9]\d*(?:-(?:[2-9]|[1-9]\d+))?)$/.test(hash)) return null
  const name = hash.slice(1)
  return pills(root).find(pill => pill.id === name || pill.getAttribute('data-comment-alias') === name) || null
}

function positionCriticPopovers (root) {
  if (!root) return
  const win = root.ownerDocument ? root.ownerDocument.defaultView : root.defaultView
  for (const popover of root.querySelectorAll('.active > .critic-comment-popover, .active > .critic-suggest-popover')) {
    if (!popover.getClientRects().length) continue
    const pill = popover.parentElement
    const anchor = pill.getBoundingClientRect()
    const pane = pill.closest('.ui-scrollable')
    const bounds = pane ? pane.getBoundingClientRect() : { top: 0, bottom: win.innerHeight }
    popover.style.visibility = anchor.bottom <= bounds.top || anchor.top >= bounds.bottom ? 'hidden' : ''
    const halfWidth = popover.getBoundingClientRect().width / 2
    const center = Math.max(halfWidth + 8, Math.min(anchor.left + anchor.width / 2, win.innerWidth - halfWidth - 8))
    popover.style.left = center + 'px'
    popover.style.top = anchor.bottom + 'px'
  }
}

module.exports = { stripCriticCoordinates, syncCriticCoordinates, highlightCriticLine, criticHashTarget, positionCriticPopovers }
